import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AuthButton } from '../../auth/auth-button/auth-button';
import { Logo } from '../../common/logo/logo';
import { SiteName } from '../../common/site-name/site-name';

@Component({
  selector: 'header[app-account-header]',
  imports: [Logo, SiteName, RouterModule, AuthButton],
  templateUrl: './account-header.html',
  styleUrl: './account-header.scss',
})
export class AccountHeader {}
